// export const BASE_URL = "http://localhost:4500/api/v1/";
export const BASE_URL = "http://5.161.83.37/api/v1/";
export default {
  // -----AUTH------//
  getUsers: BASE_URL + "user/all",
  getUserData: BASE_URL + "user",
  signUp: BASE_URL + "/user/signup",
  signIn: BASE_URL + "/user/login",
  blockUser: BASE_URL + "user/blockUser",
  getEmployees: BASE_URL + "/employee",
  updateUser: BASE_URL + "/user",

  //...................Client..............//
  getUsers: BASE_URL + "user/users",
  createClient: BASE_URL + "user/create",
  updateClient: BASE_URL + "user",
  deleteClient: BASE_URL + "user",
  logout: BASE_URL + "user/logout",
  appStats: BASE_URL + "user/appStats",

  //...................Numbers..............//
  getNumbers: BASE_URL + "number",
  createNumber: BASE_URL + "number",
  updateNumber: BASE_URL + "number",
  deleteNumber: BASE_URL + "number",

  //.......Rate Cards.........//
  getRateCard: BASE_URL + "rateCard",
  updateRateCard: BASE_URL + "rateCard",
  createRateCard: BASE_URL + "rateCard",
  deleteRateCard: BASE_URL + "rateCard",

  getAbout: BASE_URL + "aboutUs",
  updateAbout: BASE_URL + "aboutUs",
  deleteAbout: BASE_URL + "aboutUs",
};
